export const colors = {
  primaryLight: "#457b9d",
  primary: "#14213d",
  secondary: "#fca311",
  secondaryDark: "#003566",
  secondaryLight:"#1a67b3",
  red: "#E64848",
  green: "#2EB086"
}
